import get from 'lodash/get';
import Catalyst from '@Services/Catalyst';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import Auth from '@Services/Auth';
import Login from '@Services/Login';
import { loginLimitErrorType } from '@Pages/LoginLimit/LoginLimitConstants';

// eslint-disable-next-line import/prefer-default-export
export const init = async (providerId, shibbolethToken, grantType) => {
  Catalyst.trackSimpleEvent('loginStart');

  await Auth.login({ providerId, shibbolethToken }, null, { grant_type: grantType })
    .then(Login.afterAuthRedirect)
    .catch((response) => {
      const dataType = get(response, 'data.type');
      if (response.statusCode === 401 && response.type === 'CHOICE') {
        history.push({
          pathname: paths.LOGIN_ORGANIZATION,
          state: {
            response: { data: response },
          },
        });
      } else if (dataType !== loginLimitErrorType) {
        history.push({
          pathname: paths.LOGIN_INSTITUTION,
          state: {
            errorMessage: get(response, 'message'),
            loginFail: true,
          },
        });
      }
    });
};
